import React, { useState, useEffect } from "react";
import { RowsProp, DataGrid, CellParams } from '@material-ui/data-grid';
import { Toolbar, } from '@material-ui/core';
import { useHistory, generatePath } from "react-router-dom";

import { UserRepository } from 'domain/repository';
import { useRepository } from 'components/lib/Repository';
import { CustomPagination } from 'components/Pagination';
import { useFilter } from "hooks/useFilter";
import { FilterForm } from 'components/Filter';
import { UserFieldDefinition } from 'domain/model/field_difinition';
import { useIndex } from 'hooks/useIndex';
import routes from 'utils/routes';

const ignoreFields = ["password_digest", "age"]
const userFieldDefinition = UserFieldDefinition.filter(v => !ignoreFields.includes(v.field) )

export const UserIndex = () => {
  const history = useHistory();
  const userRepository = useRepository(UserRepository);
  const [rows, setRows] = useState<RowsProp>([]);
  const {
    page,
    totalPage,
    sort,
    sortingMode,
    handlePageChange,
    handleSortChange,
    changeTotal,
  } = useIndex();
  const { filters, handleSetFilters, } = useFilter();

  const handleClickCell = (param: CellParams): void => {
    const { field, value } = param;
    if (field === 'id') {
      const path = generatePath(routes.user.userShow.path, {id: value as number});
      history.push(path);
    }
  }

  useEffect(() => {
    userRepository.fetchIndex({page, sort, filters: filters}).then(res => {
      const { total } = res;
      changeTotal(total);
      setRows(res.users);
    });
  }, [page, sort, filters]);

  return (
    <>
      <Toolbar>ユーザー一覧</Toolbar>
      <FilterForm
        handleFilter={handleSetFilters}
        fieldDefinition={userFieldDefinition}
      />
      <div style={{ width: '100%', minHeight: 600 }}>
        <DataGrid
          rows={rows}
          columns={[
            {
              field: 'id',
            },
            {
              field: 'name',
              headerName:"ユーザー名",
              width: 250,
              sortable: false,
            },
            {
              field: 'email',
              headerName:"メールアドレス",
              width: 300,
            },
            {
              field: 'tel',
              headerName:"電話番号",
              width: 250,
              sortable: false,
            },
            {
              field: 'status',
              headerName:"ステータス",
              width: 200,
              sortable: false,
              flex: 1,
            },
            {
              field: 'jobHunting',
              headerName:"求職活動中",
              width: 200,
              sortable: false,
            },
            {
              field: 'isOffered',
              headerName:"オファーを受ける",
              width: 200,
              sortable: false,
            },
            {
              field: 'createdAt',
              headerName:"登録日",
              width: 200,
              sortable: false,
            },
            {
              field: 'updatedAt',
              headerName:"更新日",
              width: 200,
              sortable: false,
            },
          ]}
          pagination
          rowCount={totalPage}
          paginationMode="server"
          sortingMode={sortingMode}
          onCellClick={handleClickCell}
          onPageChange={handlePageChange}
          onSortModelChange={handleSortChange}
          components={{pagination: CustomPagination}}
          rowsPerPageOptions={[100]}
          disableColumnResize={true}
          disableColumnMenu={true}
          disableSelectionOnClick={true}
          loading={false}
        />
      </div>
    </>
  );
};
